import * as React from 'react';
import { connect } from 'react-redux';
import { setFiltroPublicacion } from '../../actions/publicacionesActions';
import {
    fetchSeller,
    editSeller,
    fetchSellersFilter,
    fetchSellers
} from '../../actions/sellersActions';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

class Moderador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            estado: "",
            envioPropio: "",
        };
        this.sufijoInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.props.seller.estado == "") {
            let seller = this.props.seller;
            seller["estado"] = "inactivo";
            this.props.editSeller(seller);
        }
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true })
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    onSwitchChangeEnvioPropio = (event) => {
        const envioPropio = event.target.checked;

        this.setState({ envioPropio, didEdit: true });

        const seller = { ...this.props.seller, envioPropio };
        this.props.editSeller(seller);

        const pathname = this.props.location?.pathname || "";
        if (pathname !== "/Sellers/Nuevo") {
            this.props.changeTab(0);
            this.props.changeTab(3);
        }
    };

    render() {
        let { seller } = this.props;
        return (
            <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">

                        <div className="form-group">
                            <label htmlFor="sufijoSKU">Sufijo SKU</label>
                            <input
                                id="sufijoSKU"
                                type="text"
                                name="sufijo"
                                maxLength="3"
                                className="form-control"
                                value={seller.sufijo || ""}
                                onChange={this.myChangeHandler}
                                ref={this.sufijoInputRef}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="empresaEnviopack">Id Empresa Enviopack</label>
                            <input
                                id="empresaEnviopack"
                                type="number"
                                className="form-control"
                                value={seller.idEmpresaEnviopack || ""}
                                onChange={this.myChangeHandler}
                                name="idEmpresaEnviopack"
                            />
                        </div>

                        <div className="form-group row">
                            <label htmlFor="switchEnvioPropio" className="control-label col-auto">Logistica propia</label>
                            <div className="col-auto">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        id="switchEnvioPropio"
                                        className="custom-control-input me-2"
                                        onChange={this.onSwitchChangeEnvioPropio}
                                        checked={seller.envioPropio ?? false}
                                    />
                                    <label htmlFor="switchEnvioPropio" className="custom-control-label">
                                        {seller.envioPropio ? "Habilitada" : "Inhabilitada"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
Moderador.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    // Redux props
    seller: PropTypes.shape({
        estado: PropTypes.string,
        sufijo: PropTypes.string,
        idEmpresaEnviopack: PropTypes.number,
        envioPropio: PropTypes.bool,
    }),
    // Actions props
    editSeller: PropTypes.func,
    changeTab: PropTypes.func
}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
});

export default connect(mapStateToProps, {
    setFiltroPublicacion,
    fetchSellersFilter,
    fetchSellers,
    fetchSeller,
    editSeller
})(Moderador);